const escapeHtml = require('stringify-entities').escape;

module.exports = function urlEmbedded(md) {
  function generateTweetByTwitterUrls(url) {
    const targetIndex = 4;
    const singleTweetURI = 'status';
    const targetURI = url.split('/')[targetIndex];
    const twitterURL = url.replace(/([\/.])x.com\//, '$1twitter.com/');

    md.helperScripts.add('https://platform.twitter.com/widgets.js');

    if (targetURI === singleTweetURI) {
      return `<div class="tweet-wrapper" data-nosnippet><blockquote class="twitter-tweet" data-lang="ja"><p lang="ja" dir="ltr"><a href="${escapeHtml(twitterURL)}">${escapeHtml(twitterURL)}</a></blockquote></div>`;
    }

    return `<div class="timeline-wrapper" data-nosnippet><a class="twitter-timeline" href="${escapeHtml(twitterURL)}" height="300"></a></div>`;
  }

  function generateVideoByYoutubeEmbedURL(embedURL) {
    const url = new URL(embedURL);

    const calcOffsetSeconds = (param) => {
      const hoursMatch = param.match(/(\d+)h/);
      const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;

      const minutesMatch = param.match(/(\d+)m/);
      const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;

      const secondsMatch = param.match(/(\d+)s?$/);
      const seconds = secondsMatch ? parseInt(secondsMatch[1], 10) : 0;

      const offset = hours * 3600 + minutes * 60 + seconds;
      return offset;
    };

    // 開始時間指定パラメーター t=123s がある場合 start=123 に変換する
    if (url.searchParams.has('t')) {
      const queryParam = url.searchParams.get('t');
      const start = calcOffsetSeconds(queryParam);
      url.searchParams.set('start', start);
      url.searchParams.delete('t');
    }
    if (url.hash.startsWith('#t=')) {
      const hashParam = url.hash.split('#t=')[1];
      const start = calcOffsetSeconds(hashParam);
      url.searchParams.set('start', start);
      url.hash = '';
    }

    return `<div class="youtube-wrapper"><iframe loading="lazy" src="${escapeHtml(url.toString())}" frameborder="0" allowfullscreen></iframe></div>`;
  }

  function generateVideoByYoutubeComUrls(url) {
    if (url.match(/www\.youtube\.com\/(?:embed\/|watch\?v=)(.+)/) === null) {
      return null;
    }
    const embedURL = url.replace(/youtube.com\/(embed\/)?/, 'youtube.com/embed/').replace(/watch\?v=/, '').replace(/&/, '?');
    return generateVideoByYoutubeEmbedURL(embedURL);
  }

  function generateVideoByYoutuBeUrls(url) {
    if (url.match(/youtu\.be\/(.+)/) === null) {
      return null;
    }

    const embedURL = url.replace(/youtu\.be\/(embed\/)?/, 'youtube.com/embed/');
    return generateVideoByYoutubeEmbedURL(embedURL);
  }

  function generateVideoByNiconicoVideoID(videoID) {
    const embedURL = `https://embed.nicovideo.jp/watch/${videoID}/script?w=640&h=360`;
    return `<div style="overflow: scroll"><script type="application/javascript" src="${escapeHtml(embedURL)}"></script></div>`;
  }

  function generateVideoByNiconicoLiveID(liveID) {
    const embedURL = `https://live.nicovideo.jp/embed/${liveID}`;
    return `<div style="overflow: scroll"><iframe width="312" height="176" src="${escapeHtml(embedURL)}" scrolling="no" style="border:solid 1px #d0d0d0; background-color: #f6f6f6;" frameborder="0"></iframe></div>`;
  }

  function generateVideoByNiconicoUrls(url) {
    const m = url.match(/(?:www|sp)\.nicovideo\.jp\/watch\/([A-z]*\d+)/);
    if (m === null) {
      return null;
    }

    const videoID = m[1];

    return generateVideoByNiconicoVideoID(videoID);
  }

  function generateVideoByNiconicoLiveUrls(url) {
    const m = url.match(/live.?\.nicovideo\.jp\/(?:watch|gate)\/(lv\d+)/);
    if (m === null) {
      return null;
    }

    const liveID = m[1];

    return generateVideoByNiconicoLiveID(liveID);
  }

  function generateVideoByNicoMsUrls(url) {
    const m = url.match(/nico\.ms\/([A-z]*\d+)/);
    if (m === null) {
      return null;
    }

    const contentID = m[1];

    if (contentID.startsWith('lv')) {
      return generateVideoByNiconicoLiveID(contentID);
    }

    return generateVideoByNiconicoVideoID(contentID);
  }

  const preTester = /https?:\/\//;
  const urlMatcher = /https?:\/\/[^\s\/$.?#]+\.[^\s\/]+\/[a-z0-9._()<>{};:*@=!$%&~|\[\]+,\-\/?&#]*/ig;

  const prefixes = [
    ['https://twitter.com/', generateTweetByTwitterUrls],
    ['http://twitter.com/', generateTweetByTwitterUrls],
    ['https://mobile.twitter.com/', generateTweetByTwitterUrls],
    ['http://mobile.twitter.com/', generateTweetByTwitterUrls],
    ['https://x.com/', generateTweetByTwitterUrls],
    ['http://x.com/', generateTweetByTwitterUrls],
    ['https://mobile.x.com/', generateTweetByTwitterUrls],
    ['http://mobile.x.com/', generateTweetByTwitterUrls],
    ['http://www.youtube.com/', generateVideoByYoutubeComUrls],
    ['https://www.youtube.com/', generateVideoByYoutubeComUrls],
    ['http://youtu.be/', generateVideoByYoutuBeUrls],
    ['https://youtu.be/', generateVideoByYoutuBeUrls],
    ['http://nico.ms/', generateVideoByNicoMsUrls],
    ['https://nico.ms/', generateVideoByNicoMsUrls],
    ['http://www.nicovideo.jp/', generateVideoByNiconicoUrls],
    ['https://www.nicovideo.jp/', generateVideoByNiconicoUrls],
    ['http://sp.nicovideo.jp/', generateVideoByNiconicoUrls],
    ['https://sp.nicovideo.jp/', generateVideoByNiconicoUrls],
    ['http://live.nicovideo.jp/', generateVideoByNiconicoLiveUrls],
    ['https://live.nicovideo.jp/', generateVideoByNiconicoLiveUrls],
    ['http://live2.nicovideo.jp/', generateVideoByNiconicoLiveUrls],
    ['https://live2.nicovideo.jp/', generateVideoByNiconicoLiveUrls],
  ];

  function replace(state, token) {
    const result = [];

    if (!preTester.test(token.content)) {
      return [token];
    }

    let matched;
    let beforeMatched = 0;

    // eslint-disable-next-line no-cond-assign
    while ((matched = urlMatcher.exec(token.content)) !== null) {
      for (const [prefix, generator] of prefixes) {
        if (!matched[0].startsWith(prefix)) {
          continue;
        }

        const preTextToken = new state.Token('text', '', 0);
        preTextToken.content = token.content.slice(beforeMatched, matched.index);
        preTextToken.level = token.level;
        result.push(preTextToken);

        const generated = generator(matched[0]) || matched[0];
        const embeddedContentToken = new state.Token('html_inline', '', 0);
        embeddedContentToken.content = `</p>${generated}<p>`;
        embeddedContentToken.level = token.level;
        result.push(embeddedContentToken);

        beforeMatched = urlMatcher.lastIndex;
      }
    }

    const postTextToken = new state.Token('text', '', 0);
    postTextToken.content = token.content.slice(beforeMatched);
    postTextToken.level = token.level;
    result.push(postTextToken);

    return result;
  }

  md.core.ruler.push('url_embedded', function urlEmbedded(state) {
    const nest = [];

    for (let i = 0; i < state.tokens.length; i++) {
      const current = state.tokens[i];

      if (current.type !== 'inline' || !preTester.test(current.content) || nest[nest.length - 1] !== 'p') {
        if (current.nesting === 1) {
          nest.push(current.tag);
        }
        if (current.nesting === -1) {
          nest.pop();
        }
        continue;
      }

      const children = [];
      for (let j = 0; j < current.children.length; j++) {
        if (current.children[j].type !== 'text') {
          children.push(current.children[j]);
          continue;
        }

        const replacedTokens = replace(state, current.children[j]);
        for (const replacedToken of replacedTokens) {
          children.push(replacedToken);
        }
      }

      current.children = children;
    }
  });
};
